import React, {useState} from 'react';
import {Stack, Text, Banner, Table, Checkbox} from '@chaser/components';
import useOrganisation from '../../../../../../hooks/useOrganisation';

const SubsidiariesList = () => {
  const {Subsidiaries} = useOrganisation();
  const [showDisabled, setShowDisabled] = useState(false);

  const data = Subsidiaries || [];
  const hasDisabled = data.some(sub => !sub.enabled);
  const filteredData = showDisabled ? data : data.filter(sub => sub.enabled);

  const baseColumns = [
    {
      accessor: 'id',
      header: 'Id',
      cell: value => <Text color="Mid Neutral 1">{value || 'N/A'}</Text>,
      headerStyle: { width: '80px' },
    },
    {
      accessor: 'name',
      header: 'Name',
      cell: value => <Text color="Mid Neutral 1">{value || 'N/A'}</Text>,
    },
  ];

  const toggleColumn = hasDisabled ? {
    accessor: 'showDisabledToggle',
    header: () => (
      <Checkbox
        checked={showDisabled}
        onChange={() => setShowDisabled(!showDisabled)}
        label="Show disabled"
      >
        Show disabled
      </Checkbox>
    ),
    cell: (_, row) => {
      if (showDisabled) {
        return (<Text color={row.enabled ? 'Green AA' : 'Red AA'}>{row.enabled ? 'Enabled' : 'Disabled'}</Text>);
      }
    },
    headerStyle: {textAlign: 'left', width: '250px'},
  } : null;

  const columns = toggleColumn ? [...baseColumns, toggleColumn] : baseColumns;

  return (
    <Stack>
      <Stack gap="medium">
        <Text fontSize="heading.4" fontWeight="bold">
          Netsuite - Subsidiaries
        </Text>

        <Table data={filteredData} columns={columns} keyField="id" layout="table"/>

        {Subsidiaries.length > 1 && (
          <Banner intent="info" showCloseButton={false}>
            Data retrieval will be performed only from enabled subsidiaries. If you need to enable /
            disable subsidiaries, please contact customer support.
          </Banner>
        )}
      </Stack>
    </Stack>
  );
};

export default SubsidiariesList;
